import React from 'react';
import { PageFooter } from '@scholastic/volume-react';
import './Footer.scss';

const Footer = () => {
    return (
        <PageFooter className="footer" />
    );
}

export default Footer;